export default __webpack_public_path__ + "925f6baa42cf5756e539993b53128003.png";